var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { AppBar, Toolbar, MuiThemeProvider, Typography, useTheme, useMediaQuery, Tooltip, IconButton, Button, } from "@material-ui/core";
import { complaintsTheme } from "../ComplaintsModuleTheme";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUrlSearch } from "../../redux/selectors";
const COMPLAINTS_HOME_PATH = "/complaints";
export const SecondaryAppBar = props => {
    var _a;
    const searchFromRedux = useSelector(selectUrlSearch)[COMPLAINTS_HOME_PATH];
    const complaintsLink = `${COMPLAINTS_HOME_PATH}${searchFromRedux || ""}`;
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    return (React.createElement(MuiThemeProvider, { theme: complaintsTheme },
        React.createElement(AppBar, { className: props.hasSubBar ? "SecondaryAppBarWithSub RevealAppBar" : "RevealAppBar" },
            React.createElement(Toolbar, { className: isMdUp ? "SecondaryAppBar" : "SecondaryAppBar NoLeft" },
                React.createElement(Typography, { className: "NavTitle", variant: "h5", align: "left" },
                    React.createElement(Link, { to: complaintsLink, "data-test-id": "secondary-header-root-link" }, "CWM"),
                    "\u00A0",
                    React.createElement("span", { "data-test": "header-case-title" }, props.title)),
                React.createElement("div", { className: "ActionButtons" },
                    React.createElement("div", { className: "ActionButtonsContent" }, props.children),
                    React.createElement("div", { className: "ActionButtonsIconButtons" }, (_a = props.actions) === null || _a === void 0 ? void 0 : _a.map((action, index) => {
                        if (isMdUp) {
                            return (React.createElement("span", { key: index },
                                React.createElement(Button, Object.assign({ key: index }, action), action.title)));
                        }
                        else {
                            let { title, startIcon } = action, newAction = __rest(action, ["title", "startIcon"]);
                            return (React.createElement(Tooltip, { title: title, key: index },
                                React.createElement(IconButton, Object.assign({}, newAction), startIcon)));
                        }
                    })))))));
};
